import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { MapPin, CheckCircle } from 'lucide-react';

const ServiceAreaPage = () => {
  const areas = [
    { region: 'South Shore', towns: ['Quincy', 'Braintree', 'Weymouth', 'Hingham', 'Norwell', 'Scituate', 'Marshfield', 'Duxbury', 'Plymouth'] },
    { region: 'Greater Boston', towns: ['Boston', 'Cambridge', 'Brookline', 'Newton', 'Somerville', 'Medford', 'Malden', 'Everett'] },
    { region: 'Plymouth County', towns: ['Plymouth', 'Kingston', 'Pembroke', 'Hanover', 'Rockland', 'Whitman', 'Hanson', 'Halifax'] },
    { region: 'Norfolk County', towns: ['Quincy', 'Braintree', 'Milton', 'Canton', 'Stoughton', 'Randolph', 'Holbrook', 'Avon'] },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="pt-24 pb-16 bg-gradient-to-br from-blue-50 via-cyan-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Service Area</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide on-site and remote IT support throughout the South Shore and Greater Boston area.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {areas.map((area, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-white" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900">{area.region}</h2>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  {area.towns.map((town, idx) => (
                    <div key={idx} className="flex items-center space-x-2">
                      <CheckCircle className="w-4 h-4 text-blue-600" />
                      <span className="text-gray-600 text-sm">{town}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-blue-50 rounded-xl p-8 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Remote Support Available Everywhere</h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              While we provide on-site support in the areas listed above, our remote support services are available to clients anywhere. Contact us to discuss your needs.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServiceAreaPage;
